export interface Location {
    id: string;
    name: string;
    display: string;
    display64: string;
}

export const defaultLocation: Location = { id: '', name: '', display: '', display64: '' };